import {
    Box, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Collapse, Divider, Grid, IconButton, IconButtonProps, Paper, Stack, styled, Table, TableBody,
    TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useEffectOnce, useMediaQuery } from 'usehooks-ts';
import GenerateReportHeading from '../../../app/common/reportsHeading/GenerateReportHeading';
import { withNavbar } from '../../../app/layout/HOC';
import SkeltonAnimation from '../../../app/layout/SkeltonAnimation';
import { Ta1AdminKobhoved } from '../../../app/models/partners';
import { useStore } from '../../../app/stores/store';
import { koReportingContainerStyles } from '../../basicUser/koreporting/reports/koReportingContainerStyles';
import T1aPartnerForm from '../forms/T1aPartnerForm';
import { adminUserStyles } from './adminUserStyles';
import NewT1aPartnerFormContainer from './NewT1aPartnerFormContainer';
import T1aPartnerModal from './T1aPartnerModal';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { mainStyles } from '../../mainStyles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const StyledTableCell = styled(TableCell)(() => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#fcfcfc',
        fontSize: 16,
        fontWeight: 300,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontWeight: 300,
        fontStrethed: 'expanded',
    },
}));
const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
        backgroundColor: '#DAE5F1',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#fcfcfc',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const gridContainer = {
    xs: 1,
    sm: 2,
    md: 3
} as const;
const textGen = (title: string, value: any, xs: number, sm: number) => {
    return <Grid item xs={xs} sm={sm} key={title}>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
        >
            {title}&nbsp;{value || "---"}
        </Stack>
    </Grid>
}

interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
}
const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const T1aPartners = () => {

    const [showFormContainer, setShowFormContainer] = useState(false);
    const [pickupNo, setPickupNo] = useState<string | null>(null);

    const { modalStore,
        adminStore: { loadAdminKobhoveds, adminKobhoveds, adminKobhovedsLoading,
            selectAllHandler, adminKobhovedCheckHandler,
            isSelectAll } } = useStore();

    const { openModal } = modalStore;

    const matches = useMediaQuery('(min-width:900px)');

    const handlePickupNoCollapse = (pNo: string) => {
        if (pickupNo === pNo) {
            setPickupNo(null);
        } else {
            setPickupNo(pNo);
        }
    };
    useEffectOnce(() => {
        loadAdminKobhoveds();
    })

    const checkBoxHandler = (id: string) => {
        if (id) {
            adminKobhovedCheckHandler(id);
        }
    };

    const showFormContainerHandler = () => {
        if (adminKobhoveds.some(x => x.isChecked))
            setShowFormContainer(true);
    }
    const showFormContainerCloseHandler = () => {
        setShowFormContainer(false);
    }

    return (
        <Box component='div' sx={{ mt: 20 }}>
            {adminKobhovedsLoading && <SkeltonAnimation iteration={10} />}
            {!adminKobhovedsLoading && !showFormContainer && adminKobhoveds.length > 0 &&
                <GenerateReportHeading heading='Search and Create Partner' />
            }
            {adminKobhoveds.length < 1 && !adminKobhovedsLoading &&
                <Typography variant='h4' textAlign='center' sx={{ mt: 5, color: '#072B02' }} >No records found</Typography>}

            {!adminKobhovedsLoading && !showFormContainer &&
                (<T1aPartnerForm showFormContainerHandler={showFormContainerHandler} isChecked={adminKobhoveds.some(x => x.isChecked)} />)
            }
            {/*Desktop view */}
            {matches && !adminKobhovedsLoading && adminKobhoveds.length > 0 && !showFormContainer &&
                <Box component="div">
                    <Divider sx={{ height: 20 }} />
                    <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                        <Table aria-label="Partner table">
                            <TableHead key={'tableKey'}>
                                <TableRow sx={{ backgroundColor: '#fcfcfc' }}>
                                    <StyledTableCell>
                                        <Checkbox
                                            checked={isSelectAll}
                                            value={isSelectAll}
                                            onChange={selectAllHandler}
                                            inputProps={{ 'aria-label': 'allControlled' }}
                                            sx={adminUserStyles.adminCheckBoxStyle}
                                        /></StyledTableCell>
                                    <StyledTableCell>More</StyledTableCell>
                                    <StyledTableCell>Partners</StyledTableCell>
                                    <StyledTableCell>Orders</StyledTableCell>
                                    <StyledTableCell>Partner No</StyledTableCell>
                                    <StyledTableCell>Partner Name</StyledTableCell>
                                    <StyledTableCell>Reseller No</StyledTableCell>
                                    <StyledTableCell>Reseller Name</StyledTableCell>
                                    <StyledTableCell>Customer No</StyledTableCell>
                                    <StyledTableCell>Customer Name</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {adminKobhoveds.map((t1a: Ta1AdminKobhoved, index) =>
                                    <StyledTableRow
                                        key={t1a.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <StyledTableCell>
                                            <Checkbox
                                                checked={t1a.isChecked}
                                                value={t1a.isChecked}
                                                onChange={() => checkBoxHandler(t1a.id)}
                                                inputProps={{ 'aria-label': t1a.id }}
                                                sx={adminUserStyles.adminCheckBoxStyle}
                                            />
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Button variant='text' onClick={() => openModal(<T1aPartnerModal partnerData={t1a}
                                            />)}>
                                                More
                                            </Button>
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.partnerKobHoveds.length}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.naviLines.length}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.partnerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.partnerName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.resellerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.resellerName}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.customerNo}
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {t1a.customerName}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box>
                    </Box>
                </Box>
            }
            {/*Mobile View */}
            {!matches && !adminKobhovedsLoading && adminKobhoveds.length > 0 && !showFormContainer &&
                <Box sx={{ flexGrow: 1, mt:4 }}>
                    <Grid container spacing={2} direction="column" justifyContent="center"
                        alignItems="center">
                        {adminKobhoveds.map((t1a: Ta1AdminKobhoved, index) => {
                            return (
                                <Grid item xs={12} key={t1a.id}
                                    sx={{
                                        position: 'relative', pb: 0.5, pr: 0.5, mt: 2,
                                        bgcolor: '#000',
                                        borderRadius: '100% 0% 29% 71% / 0% 100% 0% 100% '
                                    }} >
                                    <Typography component='span' variant='body2'
                                        sx={{ position: 'absolute', right: 6, top: 0.1, color: '#fff' }}>
                                        Tier1Asset
                                    </Typography>
                                    <Card sx={mainStyles.cardStyles}>
                                        <CardHeader
                                         action={
                                            <Checkbox
                                            checked={t1a.isChecked}
                                                value={t1a.isChecked}
                                                onChange={() => checkBoxHandler(t1a.id)}
                                                inputProps={{ 'aria-label': t1a.id }}
                                                sx={adminUserStyles.adminCheckBoxStyle}
                                            />
                                        }
                                            title={t1a.partnerName}
                                            subheader={t1a.partnerNo}
                                        />
                                        <CardContent>
                                            <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                {textGen('Total no. of partners:',t1a.partnerKobHoveds.length , 12, 6)}
                                                {textGen('Total no. of orders:', t1a.naviLines.length, 12, 6)}
                                            </Grid>
                                        </CardContent>
                                        <CardActions disableSpacing>
                                            <ExpandMore
                                                expand={pickupNo === t1a.id}
                                                onClick={() => handlePickupNoCollapse(t1a.id)}
                                                aria-expanded={pickupNo === t1a.id}
                                                aria-label="More info"
                                            >
                                                <ExpandMoreIcon />
                                            </ExpandMore>
                                        </CardActions>
                                        <Collapse in={pickupNo === t1a.id} timeout="auto" unmountOnExit>
                                            <CardContent>
                                                <Grid container direction='row' wrap='wrap' rowSpacing={1} columnSpacing={gridContainer}>
                                                    {textGen('Reseller Name:', t1a.resellerName, 12, 6)}
                                                    {textGen('Reseller No.:', t1a.resellerNo, 12, 6)}
                                                    {textGen('Customer Name:', t1a.customerName, 12, 6)}
                                                    {textGen('Customer No.:', t1a.customerNo, 12, 6)}
                                                </Grid>
                                            </CardContent>
                                        </Collapse>
                                    </Card>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            }
            {!adminKobhovedsLoading && showFormContainer &&
                <NewT1aPartnerFormContainer selectedKobhoveds={adminKobhoveds.filter(x => x.isChecked)} backBtnHandler={showFormContainerCloseHandler} />
            }
        </Box>
    )
}
const T1aPartnersPage = withNavbar(observer(T1aPartners));
export default T1aPartnersPage;